import _slugify from 'slugify';
import viCharMap from 'vi-charmap';
_slugify.extend(viCharMap);
export default function slugify(text) {
    const tmp = _slugify(text, { lower: true });
    return tmp.replace(/[^\w-]/gi, '');
}
//# sourceMappingURL=slugify.js.map